
define('text!plugins/richtext/setupTemplate.html',[],function () { return '';});

